/**
 * A hairline between two groups in the same panel.
 *
 * @module components/ui/Divider
 */

import React from "react";

export interface DividerProps {
  /** A word or two naming what follows, sat in the rule. */
  label?: string;
  className?: string;
  "data-testid"?: string;
}

export function Divider({
  label = undefined,
  className = "",
  "data-testid": testId,
}: DividerProps): React.ReactElement {
  if (label) {
    return (
      <div
        className={`flex items-center gap-3 ${className}`.trim()}
        data-testid={testId}
        role="separator"
        aria-label={label}
      >
        <span className="h-px grow bg-base-300" />
        {/* The separator's name is authored, so the copy in the rule would be
            read a second time straight after it. */}
        <span
          aria-hidden="true"
          className="text-xs font-semibold tracking-wide text-muted uppercase"
        >
          {label}
        </span>
        <span className="h-px grow bg-base-300" />
      </div>
    );
  }
  return <hr className={`border-base-300 ${className}`.trim()} data-testid={testId} />;
}

export default Divider;
